export default "__VITE_ASSET__ad0906b6__"